/** Статуси записів журналу обміну ERP (backend ExchangeQueueStatus) з кольорами бейджів */
export const EXCHANGE_STATUS_OPTIONS = [
    { value: 'awaiting', label: 'Очікує', color: '#4a9eff' },
    { value: 'processing', label: 'Обробляється', color: '#faad14' },
    { value: 'completed', label: 'Завершено', color: '#52c41a' },
    { value: 'error', label: 'Помилка', color: '#ff4d4f' },
    { value: 'import_pending', label: 'Очікує імпорту', color: '#9254de' },
]

/** Типи операцій (backend ExchangeQueueType) */
export const EXCHANGE_TYPE_OPTIONS = [
    { value: 'create', label: 'Створення', color: '#13c2c2' },
    { value: 'update', label: 'Оновлення', color: '#d4b106' },
    { value: 'delete', label: 'Видалення', color: '#fa541c' },
]

/** Статуси, з яких запис можна запустити на обробку вручну */
export const EXCHANGE_PROCESSABLE_STATUSES = ['import_pending', 'error']
